import type { CellDisplay } from "./pdp-variants-utils";

export const ComparisonCell: React.FC<{ cell: CellDisplay }> = ({ cell }) => {
  switch (cell.kind) {
    case "empty":
      return <>—</>;
    case "text":
      return <>{cell.text}</>;
    case "rich-text":
      return <>{cell.text}</>;
    case "image":
      return (
        <figure className="flex max-w-[220px] flex-col gap-1">
          <img
            src={cell.image.url}
            alt={cell.image.title ?? ""}
            width={cell.image.width}
            height={cell.image.height}
            className="max-h-[160px] max-w-full object-contain"
            loading="lazy"
          />
          {cell.image.title && <figcaption className="text-x2ss text-gray-dark-2024">{cell.image.title}</figcaption>}
        </figure>
      );
    case "media-gallery":
      return (
        <div className="flex max-w-[320px] flex-wrap gap-2">
          {cell.items.map((item, index) => {
            if (item.kind === "image") {
              return (
                <img
                  key={`${item.image.url}-${index}`}
                  src={item.image.url}
                  alt={item.image.title ?? ""}
                  className="size-[130px] object-contain"
                  loading="lazy"
                />
              );
            }

            return (
              <div
                key={`video-${index}`}
                className="flex h-[80px] w-[80px] flex-col items-center justify-center gap-1 bg-gray-light-2024 text-center text-x1"
              >
                {item.posterUrl ? (
                  <img src={item.posterUrl} alt={item.label} className="h-full w-full object-contain" loading="lazy" />
                ) : (
                  <span>{item.label}</span>
                )}
              </div>
            );
          })}
        </div>
      );
    case "attribute":
      return (
        <div className="flex max-w-[280px] flex-col gap-1">
          <div className="flex items-center gap-2">
            {cell.attribute.colorHex && (
              <span
                className="inline-block size-4 shrink-0 rounded-full border border-solid border-gray-2024"
                style={{ backgroundColor: cell.attribute.colorHex }}
                title={cell.attribute.colorHex}
              />
            )}
            <span className="font-futura-500">{cell.attribute.valueText}</span>
          </div>
          {cell.attribute.detailText && (
            <span className="text-x1 text-gray-dark-2024">{cell.attribute.detailText}</span>
          )}
          {cell.attribute.colorHex && (
            <span className="font-mono text-x2s text-gray-dark-2024">{cell.attribute.colorHex}</span>
          )}
          {cell.attribute.image && (
            <img
              src={cell.attribute.image.url}
              alt={cell.attribute.image.title ?? cell.attribute.valueText}
              className="max-h-[80px] max-w-full object-contain"
              loading="lazy"
            />
          )}
          {cell.attribute.includeInTechSpec && (
            <span className="text-x2ss uppercase tracking-wide text-gray-dark-2024">In tech spec</span>
          )}
        </div>
      );
  }
};
